// Refer to this: https://gist.github.com/0x263b/2bdd90886c2036a1ad5bcf06d6e6fb37
export const getHashedColor = (text: string, hex = true): string => {
  // First generate a hash based on the input string
  let hash = 0;

  for (let i = 0; i < text.length; i++) {
    hash = text.charCodeAt(i) + ((hash << 5) - hash);
    hash = hash & hash;
  }

  // Second, generate the rgb colors according to the hash
  let rgb = [0, 0, 0];
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 255;
    rgb[i] = value;
  }

  if (hex) {
    // Transform the rgb values to hex format
    let color = '#';
    for (var i = 0; i < 3; i++) {
      // '00' is for the padding zero problem for the single digit value
      color += ('00' + rgb[i].toString(16)).substr(-2);
    }
    return color;
  } else {
    return `rgb(${rgb[0]}, ${rgb[1]}, ${rgb[2]})`;
  }
};
